import axios from 'axios'
import {Message} from 'element-ui'
import {getToken, removeAll} from './auth'
import {restUrl} from "../../url";
import store from '../store'

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: restUrl,
  // 超时
  timeout: 60000
})
// request拦截器
service.interceptors.request.use(config => {
  if (config.content) {
    axios.defaults.headers['Content-Type'] = config.content
  }
  // 是否需要设置 token
  if (getToken()) {
    config.headers.common['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }
  // get请求映射params参数
  if (config.method === 'get' && config.params) {
    let url = config.url + '?';
    for (const propName of Object.keys(config.params)) {
      const value = config.params[propName];
      var part = encodeURIComponent(propName) + "=";
      if (value !== null && typeof (value) !== "undefined") {
        if (typeof value === 'object') {
          for (const key of Object.keys(value)) {
            let params = propName + '[' + key + ']';
            var subPart = encodeURIComponent(params) + "=";
            url += subPart + encodeURIComponent(value[key]) + "&";
          }
        } else {
          url += part + encodeURIComponent(value) + "&";
        }
      }
    }
    url = url.slice(0, -1);
    config.params = {};
    config.url = url;
  }
  return config
}, error => {
  console.log(error)
  Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(res => {
    // 未设置状态码则默认成功状态
    const code = parseFloat(res.data.status);
    // 获取错误信息
    const msg = res.data.message;
    if (code === 600) {
      Message({
        message: '登录状态已过期',
        type: 'error'
      });
      removeAll();
      location.href = '/';
      store.commit('emptyVisitedView')
    } else if (code !== 200 && code !== 205) { // 205暂无数据
      Message({
        message: msg ? msg : '未知异常',
        type: 'error'
      });
      return Promise.reject('error');
    } else {
      if (res.headers.authorization) {
        localStorage.setItem('user_token', res.headers.authorization);
      }
      return res.data
    }
  },
  error => {
    let {message} = error;
    if (message == "Network Error") {
      message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
      message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
      message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({
      message: message,
      type: 'error'
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js